import { PaymentDetails } from "../../../controlKitchenTypes"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { IconProp, library } from "@fortawesome/fontawesome-svg-core"
import { fal } from "@fortawesome/pro-light-svg-icons"
import { fas } from "@fortawesome/pro-solid-svg-icons"
import { Stack } from "@mui/material"
import { IconType } from "../../../../supplier/admin/account/gdpr/gdprTypes"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { makeStyles } from "tss-react/mui"
import { tailwindPalette } from "../../../../theme/tailwindPalette"

library.add(fal, fas)

const useStyles = makeStyles()(() => ({
    paymentIcon: {
        marginRight: ".5rem",
        color: tailwindPalette.sky[500],
    },
    paymentImg: {
        marginRight: ".5rem",
        width: "1.5rem",
    },
}))

export function PaymentMethodCell({ paymentDetails }: { paymentDetails: PaymentDetails }) {
    const { classes } = useStyles()

    const { l10n } = useAppLocalization()
    const paymentMethod = paymentDetails?.method
    const paymentMethodIcon = paymentDetails?.paymentMethod?.icon

    if (paymentMethod) {
        return (
            <Stack direction="row" justifyContent="center" alignItems="center">
                {paymentMethodIcon?.type === IconType.FONT_AWESOME && (
                    <FontAwesomeIcon
                        className={classes.paymentIcon}
                        size="lg"
                        icon={paymentMethodIcon?.spec.split(" ") as IconProp}
                    />
                )}
                {paymentMethodIcon?.type === IconType.IMAGE_URL && (
                    <img className={classes.paymentImg} src={paymentMethodIcon?.url} />
                )}
                {l10n.getStringForEnum("purchases-payment-method", paymentMethod, paymentMethod)}
            </Stack>
        )
    }

    return <></>
}
